/* Too Munchies · pop-up de bienvenida (captura de correo para el descuento de primera compra) */
(function () {
  'use strict';

  var KEY = 'tm_popup_hide_until';
  var SUBMIT_KEY = 'tm_popup_submitted';

  function store(get, key, value) {
    try {
      if (get) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }
  function session(get, key, value, remove) {
    try {
      if (remove) { window.sessionStorage.removeItem(key); return null; }
      if (get) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  class TmPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tmInit) return;
      this.dataset.tmInit = '1';
      this.delay = (parseInt(this.dataset.delay || '4', 10) || 0) * 1000;
      this.days = parseInt(this.dataset.days || '15', 10) || 15;
      this.isOpen = false;

      this.querySelectorAll('[data-tm-popup-close]').forEach(function (el) {
        el.addEventListener('click', function () { this.close(true); }.bind(this));
      }, this);
      this.querySelectorAll('[data-tm-popup-option]').forEach(function (btn) {
        btn.addEventListener('click', function () { this.chooseOption(btn); }.bind(this));
      }, this);
      var form = this.closest('form');
      if (form) form.addEventListener('submit', function () { session(false, SUBMIT_KEY, '1'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && this.isOpen) this.close(true); }.bind(this));

      var submitted = session(true, SUBMIT_KEY) === '1';
      if (submitted) session(false, SUBMIT_KEY, null, true);

      if (this.hasAttribute('data-success')) {
        if (submitted || window.location.hash === '#TmPopupForm') {
          this.hideFor(365);
          try { window.scrollTo(0, 0); window.history.replaceState(null, '', window.location.pathname); } catch (e) {}
          this.open();
        }
        return;
      }
      if (this.hasAttribute('data-error')) {
        if (submitted) { this.showStep('2'); this.open(); }
        return;
      }
      if (this.hasAttribute('data-design-mode')) return;
      if (this.isSnoozed()) return;
      if (this.dataset.mobile === 'false' && window.innerWidth < 750) return;
      var self = this;
      setTimeout(function () { self.open(); }, this.delay);
    }

    isSnoozed() {
      var until = parseInt(store(true, KEY) || '0', 10);
      return Date.now() < until;
    }
    hideFor(days) {
      store(false, KEY, String(Date.now() + days * 864e5));
    }
    open() {
      if (this.isOpen) return;
      this.hidden = false;
      this.isOpen = true;
      document.body.classList.add('tm-popup-open');
      var self = this;
      setTimeout(function () { self.classList.add('is-open'); }, 20);
      var first = this.querySelector('[data-tm-popup-step]:not([hidden]) [data-tm-popup-option], [data-tm-popup-step]:not([hidden]) input[type="email"]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 400);
    }
    close(remember) {
      this.classList.remove('is-open');
      this.isOpen = false;
      document.body.classList.remove('tm-popup-open');
      var self = this;
      setTimeout(function () { self.hidden = true; }, 350);
      if (remember) this.hideFor(this.days);
    }
    chooseOption(btn) {
      var tag = (btn.getAttribute('data-tag') || '').trim();
      var tags = this.querySelector('[data-tm-popup-tags]');
      if (tags) tags.value = tag ? tags.getAttribute('data-base') + ',' + tag : tags.getAttribute('data-base');
      this.showStep('2');
      var email = this.querySelector('input[type="email"]');
      if (email) setTimeout(function () { try { email.focus({ preventScroll: true }); } catch (e) {} }, 120);
    }
    showStep(step) {
      this.querySelectorAll('[data-tm-popup-step]').forEach(function (el) {
        var isTarget = el.getAttribute('data-tm-popup-step') === step;
        if (isTarget) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
    }
  }

  if (!customElements.get('tm-popup')) customElements.define('tm-popup', TmPopup);

  /* Editor de temas: abrir al seleccionar la sección, cerrar al deseleccionar */
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target && e.target.querySelector ? e.target.querySelector('tm-popup') : null;
    if (p) p.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target && e.target.querySelector ? e.target.querySelector('tm-popup') : null;
    if (p) p.close(false);
  });
})();
